import { ChevronRight } from "lucide-react";
import { useTranslations } from "next-intl";
import type { ReactNode } from "react";

/**
 * Titled card shell with a header + "see all" affordance — used by the
 * list-style Home blocks (pinned-articles, news-preview).
 */
export function BlockCard({
  title,
  onOpenAll,
  children,
}: {
  title: string;
  onOpenAll: () => void;
  children: ReactNode;
}) {
  const t = useTranslations("home");
  return (
    <div className="overflow-hidden rounded-wx-lg border border-wx-border bg-wx-bg-elevated">
      <div className="flex items-center justify-between px-3.5 pt-3 pb-1.5">
        <p className="text-xs font-semibold tracking-wide text-wx-fg-muted uppercase">{title}</p>
        <button
          type="button"
          onClick={onOpenAll}
          aria-label={t("seeAll")}
          className="text-xs font-medium text-wx-primary hover:underline"
        >
          <ChevronRight size={14} className="rtl:-scale-x-100" />
        </button>
      </div>
      {children}
    </div>
  );
}
